// extracted by mini-css-extract-plugin
module.exports = {"control-row":"queue-control-row_control-row__2FUhV","section":"queue-control-row_section__23Hh8","countdown":"queue-control-row_countdown__12Ijv"};